import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

import { LANDING_COLORS } from '../../../constants'
import { hairlineBorder } from '../../../lib/hairline'

export const BridgeNoticeContainer = styled.section`
  display: flex;
  flex-direction: column;
  padding: 14px 30px 60px;
  background-color: ${COLORS.bgWhite};
`

export const NoticeBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 4px;
  background-color: ${COLORS.bgWhite};
  /* 0.5px 하단 변이 일부 webview 에서 사라지는 문제 — 레티나 헤어라인으로 대응 */
  ${hairlineBorder(COLORS.textPlaceholder)}
`

export const NoticeText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: -0.21px;
  text-align: center;
  color: ${COLORS.textSecondary};
`

export const NoticeHighlight = styled.span`
  color: ${LANDING_COLORS.positive};
`
